import { AUTHORIZATION } from "../../../constants/api/auth";
import { request } from "../api";
import { MESSAGE } from "../../../constants/api/message";
import { headers } from "../../../config/config";
import { StatusCodes } from "http-status-codes";

const { Authorization, Bearer } = AUTHORIZATION;
const { patch } = request;

export const editMemberDetailsChangeRequest = async (_payload: any, _id: string) => {
	try {
		const payload = _payload;
		const endpoint = `general/member?_id=${_id}`;
		const token = localStorage.getItem("@jwt_member");
		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			// console.log("Response data", response);
			const {
				status,
				data: { result }
			} = response;
			if (status === StatusCodes.OK) {
				return result;
			}
		}
		// throw new Error();
	} catch (err) {
		throw err;
	}
};
